import React from 'react'
import PropTypes from 'prop-types'
import { ListGroupItemHeading, ListGroupItemText, ListGroupItem } from 'reactstrap'

import './ImportListItem.scss'

class ImportListItem extends React.Component {

    static propTypes = {
        onSelect: PropTypes.func,
        selected: PropTypes.bool,
        id: PropTypes.number,
        organisatieNaam: PropTypes.string
    }

    static defaultProps = {
        selected: false,
        onSelect: () => {}
    }

    handleSelect = () => {
        this.props.onSelect(this.props.id)
    }

    render() {
        const { id, organisatieNaam, selected } = this.props

        return (
            <ListGroupItem active={ selected } onClick={ this.handleSelect } className="ao-import-list__item">
                <div className="d-flex">
                    <ListGroupItemHeading>{ id }</ListGroupItemHeading>
                    <ListGroupItemText>{ organisatieNaam || '-' }</ListGroupItemText>
                </div>
            </ListGroupItem>
        )
    }
}

export default ImportListItem
